/**
 * @flow
 * @relayHash 8b0566cbca3c14050c595a8bc0f47705
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CronList_viewer$ref = any;
export type CronListQueryVariables = {||};
export type CronListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CronList_viewer$ref
  |}
|};
export type CronListQuery = {|
  variables: CronListQueryVariables,
  response: CronListQueryResponse,
|};
*/


/*
query CronListQuery {
  viewer {
    ...CronList_viewer
    id
  }
}

fragment CronList_viewer on Query {
  adminMeta {
    systemName
  }
  crons {
    expression
    functionUrl
    awsLogUrl
    awsEventUrl
    paramDefs {
      defaultValue
      paramDefId: id
      type
      description
    }
  }
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CronListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CronList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CronListQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "adminMeta",
            "storageKey": null,
            "args": null,
            "concreteType": "AdminMeta",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "systemName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crons",
            "storageKey": null,
            "args": null,
            "concreteType": "Cron",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expression",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "functionUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "awsLogUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "awsEventUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "paramDefs",
                "storageKey": null,
                "args": null,
                "concreteType": "CronParamDefs",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "defaultValue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "paramDefId",
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CronListQuery",
    "id": null,
    "text": "query CronListQuery {\n  viewer {\n    ...CronList_viewer\n    id\n  }\n}\n\nfragment CronList_viewer on Query {\n  adminMeta {\n    systemName\n  }\n  crons {\n    expression\n    functionUrl\n    awsLogUrl\n    awsEventUrl\n    paramDefs {\n      defaultValue\n      paramDefId: id\n      type\n      description\n    }\n  }\n}\n",
    "metadata": {}
  }
};
// prettier-ignore
(node/*: any*/).hash = '17cb14c246f75a5816ef2e473c5a33bd';
module.exports = node;
